import type { AxiosError } from 'axios';

export const handleNotFoundError = (error: AxiosError) => {
    if (error?.response?.status === 404) {
        return null;
    }
    throw error;
};
